import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventsIndexComponent } from './crud-index/crud-index.component';
import { EventsCESComponent } from './crud-ces/crud-ces.component';
import { EventsIndexSelectComponent } from './crud-index/crud-index-select.component';
import { EventsCrudIndex } from './crud-index/crud-index';
import { EventsRoutingModule } from './events-routing.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DialogCloseModule } from 'src/app/shared/components/dialog-close/dialog-close.module';
import { DialogSaveCloseModule } from 'src/app/shared/components/dialog-save-close/dialog-save-close.module';
import { DynamicFormModule } from 'src/app/shared/components/dynamic-form/dynamic-form.module';
import { FieldsModule } from 'src/app/shared/components/fields/fields.module';
import { TableResponsiveModule } from 'src/app/shared/components/table-responsive/table-responsive.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { LayoutCrudIndexModule } from '../shared/layout-crud-index/layout-crud-index.module';
import { EventsTableModule } from "./crud-index/events-table/events-table.module";
import { QrCodeDialogComponent } from './qr-code-dialog/qr-code-dialog.component';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { EventsService } from './crud-service';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormEventComponent } from './form-event/form-event.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { InputDayTimeModule } from "../../../shared/components/fields/input-day-time/input-day-time.module";
import { MeetingEventComponent } from './meeting-event/meeting-event.component';
import { CustomerAcessModule } from '../customer-acess/customer-acess.module';
import { CustomersModule } from '../customers/customers.module';

@NgModule({
  declarations: [
    EventsCESComponent,
    EventsCrudIndex,
    EventsIndexComponent,
    EventsIndexSelectComponent,
    QrCodeDialogComponent,
    FormEventComponent,
    MeetingEventComponent,
  ],

  imports: [
    CommonModule,
    EventsRoutingModule,
    AngularMaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicFormModule,
    FieldsModule,
    TableResponsiveModule,
    DialogCloseModule,
    DialogSaveCloseModule,
    DialogContainerModule,
    LayoutCrudIndexModule,
    NgxQRCodeModule,
    EventsTableModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    InputDayTimeModule,
    CustomerAcessModule,
    CustomersModule
  ],
  providers: [EventsService],
})
export class EventsModule { }
